<template>
  <div class="list_index">
    <div class="heads">
      <div class="left">
        <i class="el-icon-back icon" @click="goback"></i>
        <span>{{xlh}}</span>
        <span class="m20">InConnect连接状态：
          <el-badge v-if="start == 1" class="item" type="success" :is-dot="true"></el-badge>
          <el-badge  v-else class="item" type="info" :is-dot="true"></el-badge>
        </span>
        <span class="m20">mqtt网关虚拟IP：</span>
        <el-link v-if="start == 1" :underline="false" class="font" type="primary" :href="url" target="_blank">{{vip}}</el-link>
        <span v-else>{{vip}}</span>
      </div>
      <div class="right">
       <el-button type="primary" class="yl-button" icon="el-icon-plus" @click="addDevice">{{$t('newlyAdded')}}</el-button>
      </div>
    </div>
    <div class="content">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础信息" name="info">
          <gatewayDataDetail :serialNumber="xlh"/>
        </el-tab-pane>
      </el-tabs> -->
      <el-table stripe border :data="tableData" :row-style="{height: '0'}" :cell-style="{padding: '10px'}">
          <el-table-column label="名称" prop="name" align="center"></el-table-column>
          <el-table-column label="IP地址" prop="ip" align="center"></el-table-column>
          <el-table-column label="虚拟IP" prop="vip" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top">
                <el-button @click="edit(scope.row)" class="mr10" type="text" icon="el-icon-bj" size="small"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                <el-popover
                  placement="top"
                  width="160"
                  :ref="`popover-${scope.$index}`"
                  >
                  <p style="margin-bottom:10px">确定要删除这台设备?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="deleteDevice(scope.row)">确定</el-button>
                    <el-button size="mini" type="text" @click="handleClose(scope.$index)">取消</el-button>
                  </div>
                  <el-button type="text" icon="el-icon-sc" class="ml0" size="small" slot="reference"></el-button>
                </el-popover>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="size"
            :total="count"
            @current-change="changePage"
          ></el-pagination>
        </div>
    </div>
    <el-dialog :title="type == 1?'添加终端':'修改终端'" :visible.sync="showDevice" width="30%">
      <el-form :model="form" label-position="right" label-width=".6rem" ref="add" :rules="rules">
        <el-form-item label="名称" prop="name">
            <el-input type="text" size="small" placeholder="请输入名称" v-model="form.name" class="yl-input_noIcon"></el-input>
        </el-form-item>
        <el-form-item label="ip" prop="ip">
            <el-input type="text" size="small" placeholder="请输入ip" v-model="form.ip" class="yl-input_noIcon"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" class="yl-button" @click="submit()">确 定</el-button>
          <el-button @click="canel" class="yl-button2" size="mini">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
import DeviceTemplateService from '@/api/deviceTemplate';
import gatewayDataDetail from '@/components/gateway/gatewayDataDetail/index.vue'
export default {
  components:{
    gatewayDataDetail
  },
  data(){
    return{
      online_status:1,
      vip:'',
      type:1,//1是新增，2是修改
      id:'',
      rid:'',
      page:1,
      size:10,
      count:0,
      showDevice:false,
      xlh:'',
      activeName:'info',
      tableData:[],
      name:'',
      start:'',
      form:{
        ip:'',
        serialNumber:'',
        name:''
      },
      rules:{
        name:[{ required: true,message: '请输入名称', trigger: 'blur' }],
        ip:[{ required: true,message: '请输入ip', trigger: 'blur' }],
      },
    }
  },
  computed:{
    url(){
      return `https://${this.vip}`
    }
  },
  methods:{
    goback() {
      window.history.go(-1);
    },
    //新增终端
    addDevice(){
      this.form.name = ''
      this.form.ip = ''
      this.type = 1;
      this.showDevice = true;
    },
    //修改终端
    edit(val){
      this.type = 2;
      this.form.name = val.name;
      this.form.ip = val.ip;
      this.id = val.id;
      this.rid = val.rid;
      this.showDevice = true;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getTableData(){
      DeviceTemplateService.queryLowerEndDevice({
        serialNumber:this.xlh,
        name:this.name,
        page:this.page,
        size:this.size
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
        this.vip = res.data.vip;
        this.start = res.data.start;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.getTableData();
    },
    //提交表单
    submit(){
      this.$refs.add.validate((valid)=>{
        if(valid){
          if(this.type == 1){
            DeviceTemplateService.addLowerEndDevice({...this.form}).then(res=>{
              this.$message.success('新增成功')
              this.resetForm('add');
              this.showDevice = false;
              this.getTableData();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }else{
            DeviceTemplateService.updateLowerEndDevice({
              ...this.form,
              id:this.id,
              rid:this.rid
            }).then(res=>{
              this.$message.success('修改成功')
              this.resetForm('add');
              this.showDevice = false;
              this.getTableData();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }
        }else{
          this.$message.error("请检查必填项");
          return false;
        }
      })
    },
    canel(){
      this.showDevice = false;
    },
    //删除终端
    deleteDevice(val){
      DeviceTemplateService.deleteLowerEndDevice({
        serialNumber:this.xlh,
        id:val.id
      }).then(res=>{
        this.$message.success('删除成功')
        this.getTableData()
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //取消删除
    handleClose(index){
      this.$refs[`popover-${index}`].doClose()
    },
    // getInfo(){
    //   DataService.getGatewayInformation({
    //     user_id:this.$store.state.user_id,
    //     serialNumber:this.xlh
    //   }).then(res=>{
    //     console.log(res)
    //   }).catch(err=>{
    //     this.$message.error(err.message)
    //   })
    // }
  },
  mounted(){
    if(this.$route.query){
      this.xlh = this.$route.query.xlh
      this.form.serialNumber = this.$route.query.xlh
      this.name = this.$route.query.name
    }
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.list_index{
  padding:20px;
  .heads{
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    // margin-bottom: 40px;
    .left{
        width: 1200px;
        height: 40px;
        font-size: 24px;
        color: #fff;
        display: flex;
        align-items: center;
      .icon{
        width: 24px;
        height: 24px;
        cursor: pointer;
        margin-right: 10px;
      }
      .m20,.font{
        font-size: 24px;
      }
      .m20{
        margin-left: 50px;
      }
      span{
        .item{
          // margin-bottom: 2px;
          /deep/ .el-badge__content--info{
            background-color: #d9d9d9;
            width: 15px;
            height: 15px;
            border: none;
            margin-bottom: 4px;
          }
          /deep/ .el-badge__content--success{
            width: 15px;
            height: 15px;
            border: none;
            margin-bottom: 4px;
          }
          /deep/ sup{
            top: 0;
          }
        }
      }
    }
  }
  .content{
    margin-top: 20px;
  }
}
.info{
  p{
    margin-bottom: 20px;
    font-size: 14px;
  }
}
</style>